import { SAMPLE_SIZE_ID } from "../constants";
import type { CartProduct } from "../stores/cart";

export const variantToArtnr = (variant: CartProduct) => {
    if ("artnr" in variant) {
        return variant.artnr;
    }
    return `${variant.id}-${variant.sample ? SAMPLE_SIZE_ID : variant.size.id}-${variant.color.id}${
        variant.scallop ? `-${variant.scallop.id}` : ""
    }${variant.slides ? `-${variant.slides.id}` : ""}`;
};
